export interface NormalizedPayrollRole {
  dept: string;
  title: string;
  ftes: number;
}

const DEPT_MAP: Record<string, string> = {
  "0d04c044-87bd-4d24-9007-f0628ef6ee3a": "frontOffice",
  "e156800b-55e8-4b3f-a5f9-64b8fe266512": "housekeeping",
  "d93b774f-3906-47e9-ba2f-90675588f31c": "fnb",
  "559c7da5-01f0-4a2d-9764-ad7d6fb70220": "wellness",
  "c5e5738e-0b31-4940-9b10-8ca654b9917f": "maintenance",
  "508d5c3b-c493-43f9-a796-11558a7a1fc9": "management",
  "8607eb3b-2103-4615-b96c-9eef9f282afa": "admin",
};

export function mapPayrollToRoles(payrollData: any): NormalizedPayrollRole[] {
  const positions = payrollData?.data?.positions ?? [];
  return positions
    .filter((p: any) => p.included)
    .map((p: any) => ({
      dept: DEPT_MAP[p.departmentId] ?? "other",
      title: p.positionName,
      ftes: p.overrideFTEs ?? p.calculatedFTEs ?? 0,
    }));
}
